import { Fragment, useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import FilePageService from "../../API/FilePage/FilePageService";
import Loading from "../../Common/Loading";
import SidePanel from "../../Components/SidePanel/SidePanel";
import { useNavigate, useParams } from "react-router-dom";
import Paginations from "../../Components/Paginations/Paginations";

const EditQRBasis = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams();

  const [flashMessage, setFlashMessage] = useState({ type: "", message: "" });
  const [loading, setLoading] = useState(false);
  const [questionsLoading, setQuestionsLoading] = useState(false);
  const [logoImageShow, setLogoImageShow] = useState("");
  const [rightPanelThemeColor, setRightPanelThemeColor] = useState("");

  const [questionsList, setQuestionsList] = useState([]);
  const [initialDetailsLoaded, setInitialDetailsLoaded] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    questions_id: [],
  });

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);

  useEffect(() => {
    const userRole = JSON.parse(localStorage.getItem("userRole"));
    const token = localStorage.getItem("authToken");
    if (token && userRole.includes("Administrateur")) {
      const logo_image = JSON.parse(localStorage.getItem("logo_image"));
      const right_panel_color = JSON.parse(
        localStorage.getItem("right_panel_color")
      );
      setRightPanelThemeColor(right_panel_color);
      setLogoImageShow(logo_image);
      QRBasisQuestionsList(currentPage);
    } else {
      navigate("/");
    }
  }, []);

  useEffect(() => {
    if (flashMessage.message) {
      const timer = setTimeout(() => {
        setFlashMessage({ type: "", message: "" });
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [flashMessage]);

  useEffect(() => {
    if (id && questionsList?.length != 0 && !initialDetailsLoaded) {
      ShowQRBasisDetails(id);
      setInitialDetailsLoaded(true);
    }
  }, [id, questionsList, initialDetailsLoaded]);

  const ShowQRBasisDetails = async (id) => {
    setLoading(true);
    try {
      const response = await FilePageService.qr_basis_show(id);
      if (response.data.status) {
        const details = response.data.qrBasis;

        setFormData({
          name: details.name,
          questions_id: details.question_ids,
        });

        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      setFlashMessage({
        type: "error",
        message: t("somethingWentWrong"),
      });
    }
  };

  const QRBasisQuestionsList = async (page = 1) => {
    setQuestionsLoading(true);
    try {
      var userData = {
        search: "",
        sort: {
          key: "created_at",
          value: "desc"
        },
        status: "",
        page
      }
      const response = await FilePageService.qr_basis_questionsList_page(userData);

      if (response.data.status) {
        setQuestionsLoading(false);
        setQuestionsList(response.data.questions_list.data);
        setCurrentPage(response.data.questions_list.meta.current_page);
        setTotalPages(response.data.questions_list.meta.last_page);
        setTotalRecords(response.data.questions_list.meta.total);
      }
    } catch (error) {
      setFlashMessage({
        type: "error",
        message: t("somethingWentWrong"),
      });
    } finally {
      setQuestionsLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleQuestionsChange = (questionId, isChecked) => {
    setFormData((prev) => {
      let newIds = prev.questions_id;

      if (isChecked) {
        if (!newIds.includes(questionId)) {
          newIds = [...newIds, questionId];
        }
      } else {
        newIds = newIds.filter((id) => id !== questionId);
      }

      return {
        ...prev,
        questions_id: newIds,
      };
    });
  };

  const EditQRBasis = async (e) => {
    e.preventDefault();
    if (loading) return;

    if (!formData.name || formData.questions_id.length === 0) {
      setFlashMessage({
        type: "error",
        message: t("requriedErrorMessageLabel"),
      });
      return;
    }
    setLoading(true);

    const payload = {
      name: formData.name,
      questions_id: formData.questions_id,
    };

    try {
      const response = await FilePageService.qr_basis_update(id, payload);

      if (response.data.status) {
        setFlashMessage({
          type: "success",
          message: response.data.message || t("ajouté avec succès"),
        });
        // setFormData({
        //   name: "",
        //   questions_id: []
        // })
        // setTimeout(() => {
        //   navigate("/qr-basis");
        // }, 3000);
      } else {
        setFlashMessage({
          type: "error",
          message: response.data.message || t("somethingWentWrong"),
        });
      }
    } catch (error) {
      setFlashMessage({
        type: "error",
        message: error.response?.data?.message || t("somethingWentWrong"),
      });
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    QRBasisQuestionsList(page);
  };

  return (
    <Fragment>
      <style>
        {` button.btn.btn-primary  { background-color: ${localStorage.getItem("button_color")
          ? JSON.parse(localStorage.getItem("button_color"))
          : "#e84455"
          } !Important};`}
      </style>

      <SidePanel
        sidebarLogo={
          (logoImageShow !== "" ||
            logoImageShow !== null ||
            logoImageShow !== undefined) &&
          `${process.env.REACT_APP_IMAGE_URL}/${logoImageShow}`
        }
      />

      <div
        className="dashboard-main-content user-dashboard"
        style={{ backgroundColor: rightPanelThemeColor }}
      >
        <div className="top-header">
          <div className="mt-3 d-md-flex justify-content-between align-items-center">
            <h1 className="m-md-0 mb-3">Modifier la base QR</h1>
          </div>
        </div>
        <div className="table-wrapper mt-24">
          {loading ? (
            <Loading />
          ) : (
            <>
              {/* Back Button */}
              <div className="d-block mb-2">
                <span className="back-screen" onClick={() => navigate("/qr-basis")}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="23"
                    viewBox="0 0 18 23"
                    fill="none"
                  >
                    <path
                      d="M17.4148 11.8702C17.0398 11.4952 16.5311 11.2846 16.0008 11.2846C15.4705 11.2846 14.9619 11.4952 14.5868 11.8702L11.0008 15.4562V2.28418C11.0008 1.75375 10.7901 1.24504 10.415 0.869966C10.04 0.494893 9.53125 0.28418 9.00081 0.28418C8.47038 0.28418 7.96167 0.494893 7.5866 0.869966C7.21153 1.24504 7.00081 1.75375 7.00081 2.28418V15.4562L3.41481 11.8702C3.03761 11.5059 2.53241 11.3043 2.00801 11.3088C1.48362 11.3134 0.981993 11.5237 0.611177 11.8945C0.240361 12.2654 0.0300231 12.767 0.0254662 13.2914C0.0209094 13.8158 0.222498 14.321 0.586814 14.6982L7.58681 21.6982C7.96187 22.0731 8.47049 22.2838 9.00081 22.2838C9.53114 22.2838 10.0398 22.0731 10.4148 21.6982L17.4148 14.6982C17.7898 14.3231 18.0004 13.8145 18.0004 13.2842C18.0004 12.7539 17.7898 12.2452 17.4148 11.8702Z"
                      fill="#00366B"
                    />
                  </svg>
                </span>
              </div>

              <Form onSubmit={EditQRBasis}>
                {flashMessage.message && (
                  <div
                    className={`mt-3 mx-w-620 alert ${flashMessage.type === "success"
                      ? "alert-success"
                      : "alert-danger"
                      } text-center`}
                    role="alert"
                  >
                    {flashMessage.message}
                  </div>
                )}

                <div className="mt-3">
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Nom de la base QR <span>*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Nom de la base QR"
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>
                      Questions <span>*</span>
                    </Form.Label>
                    <div
                      style={{
                        maxHeight: "400px",
                        height: "400px",
                        display: "flex",
                        flexDirection: "column",
                        border: "1px solid #ced4da",
                        borderRadius: "0.25rem",
                        padding: "10px",
                        backgroundColor: "white",
                      }}
                    >
                      {questionsLoading ?
                        <div
                          style={{
                            overflowY: "auto",
                            flexGrow: 1,
                          }}
                        >
                          <Loading />
                        </div>
                        :
                        <div
                          style={{
                            overflowY: "auto",
                            flexGrow: 1,
                          }}
                        >

                          {questionsList?.length > 0 && questionsList?.map((data, index) => (
                            <Form.Check
                              key={index}
                              type="checkbox"
                              id={`question-${data.id}`}
                              label={data.question_text}
                              checked={formData.questions_id.includes(data.id)}
                              onChange={(e) =>
                                handleQuestionsChange(
                                  data.id,
                                  e.target.checked
                                )
                              }
                              style={{ marginBottom: "5px" }}
                            />
                          ))}
                        </div>
                      }

                      {totalRecords > 10 && (
                        <div
                          style={{
                            flexShrink: 0,
                            borderTop: '1px solid #eee',
                          }}
                        >
                          <Paginations
                            currentPage={currentPage}
                            totalPages={totalPages}
                            onPageChange={handlePageChange}
                            itemsPerPage={10}
                            totalItems={totalRecords}
                          />
                        </div>
                      )}
                    </div>
                  </Form.Group>

                  {/* Submit Button */}
                  <Button
                    type="submit"
                    variant="primary"
                    className="mt-3"
                    disabled={loading}
                  >
                    {loading ? "Mise à jour..." : "Mise à jour"}
                  </Button>
                </div>
              </Form>
            </>
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default EditQRBasis;